const ORDER_CREATE_REQUEST = "ORDER_CREATE_REQUEST";
const ORDER_CREATE_SUCCESS = "ORDER_CREATE_SUCCESS";
const ORDER_CREATE_FAILURE = "ORDER_CREATE_FAILURE";
const ORDER_CREATE_RESET = "ORDER_CREATE_RESET"

const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST";
const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
const ORDER_DETAILS_FAILURE = "ORDER_DETAILS_FAILURE";

const ORDER_PAY_REQUEST = "ORDER_PAY_REQUEST";
const ORDER_PAY_SUCCESS = "ORDER_PAY_SUCCESS";
const ORDER_PAY_FAILURE = "ORDER_PAY_FAILURE";
const ORDER_PAY_RESET = "ORDER_PAY_RESET";

const ORDER_LIST_MY_REQUEST = "ORDER_LIST_MY_REQUEST";
const ORDER_LIST_MY_SUCCESS = "ORDER_LIST_MY_SUCCESS";
const ORDER_LIST_MY_FAILURE = "ORDER_LIST_MY_FAILURE";
const ORDER_LIST_MY_RESET = "ORDER_LIST_MY_RESET";

const ORDER_LIST_REQUEST = "ORDER_LIST_REQUEST";
const ORDER_LIST_SUCCESS = "ORDER_LIST_SUCCESS";
const ORDER_LIST_FAILURE = "ORDER_LIST_FAILURE";

const ORDER_DELIVER_REQUEST = "ORDER_DELIVER_REQUEST";
const ORDER_DELIVER_SUCCESS = "ORDER_DELIVER_SUCCESS";
const ORDER_DELIVER_FAILURE = "ORDER_DELIVER_FAILURE";
const ORDER_DELIVER_RESET = 'ORDER_DELIVER_RESET'

export {
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_CREATE_FAILURE,
  ORDER_CREATE_RESET,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_DETAILS_FAILURE,
  ORDER_PAY_REQUEST,
  ORDER_PAY_SUCCESS,
  ORDER_PAY_FAILURE,
  ORDER_PAY_RESET,
  ORDER_LIST_MY_REQUEST,
  ORDER_LIST_MY_SUCCESS,
  ORDER_LIST_MY_FAILURE,
  ORDER_LIST_MY_RESET,
  ORDER_LIST_REQUEST,
  ORDER_LIST_SUCCESS,
  ORDER_LIST_FAILURE,
  ORDER_DELIVER_REQUEST,
  ORDER_DELIVER_SUCCESS,
  ORDER_DELIVER_FAILURE,
  ORDER_DELIVER_RESET
};
